import React from "react"
import { useDispatch, useSelector } from "react-redux"
import { useSnackbar } from "notistack"
import _ from "lodash"
import IconButton from "@material-ui/core/IconButton"
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined"
import { useIntl } from "react-intl"
import { removeSnackbar } from "./notifierActions"

let displayed = []

/**
 * Component from https://iamhosseindhv.com/notistack/demos#redux-/-mobx-example
 *
 * @returns {null}
 * @constructor
 */
const Notifier = () => {
  const dispatch = useDispatch()
  const notifications = useSelector((store) => store.notifications || [])
  const { enqueueSnackbar, closeSnackbar } = useSnackbar()
  const { formatMessage: format } = useIntl()

  // add close action on each notification
  const closeAction = (key) => (
    <IconButton size="small" onClick={() => closeSnackbar(key)}>
      <CloseOutlinedIcon />
    </IconButton>
  )

  const storeDisplayed = (id) => {
    displayed = [...displayed, id]
  }

  const removeDisplayed = (id) => {
    displayed = [...displayed.filter((key) => id !== key)]
  }

  React.useEffect(() => {
    notifications.forEach(
      ({ key, message, options = {}, dismissed = false }) => {
        if (dismissed) {
          // dismiss snackbar using notistack
          closeSnackbar(key)
          return
        }

        // do nothing if snackbar is already displayed
        if (displayed.includes(key)) {
          return
        }

        // handle translation when necessary
        const translatedMsg =
          _.isObject(message) && message.id
            ? format(message, options.intlOptions)
            : message

        // display snackbar using notistack
        enqueueSnackbar(translatedMsg, {
          key,
          ...options,
          action: closeAction,
          onClose: (event, reason, myKey) => {
            if (options.onClose) {
              options.onClose(event, reason, myKey)
            }
          },
          onExited: (event, myKey) => {
            // removen this snackbar from redux store
            dispatch(removeSnackbar(myKey))
            removeDisplayed(myKey)
          }
        })

        // keep track of snackbars that we've displayed
        storeDisplayed(key)
      }
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notifications, closeSnackbar, enqueueSnackbar, dispatch])

  return null
}

export default Notifier
